export default {
  loading: false,
  mgmt_contract_nos: [],
  mgmt_contract_no: {},
  totalCount: 0,
};
